import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'

import ComboBox from 'Components/ComboBox'
import { Input } from 'Components/Input'
import { makeGetRequest, makePostRequest } from 'utils/api'
import urls from 'utils/urls'

export default function CreateCarModel({
  fetchCarModel,
  setAddModel,
  vehiculesTypes,
  fetchCarPicModel,
  carLogoTypes,
  selectedVehicleTypes,
  selectedMarques,
}) {
  const [selectedMarque, setSelectedMarque] = useState(null)
  // const [selectedVehicleType, setSelectedVehicleType] = useState(selectedVehicleTypes)
  const [carMarque, setCarMarque] = useState([])

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      vehicletype: '',
      Marque: '',
      Emission: '',
      Name: '',
    },
  })

  useEffect(() => {
    // fetchPays()
  }, [])

  const handleClose = () => {
    setAddModel(false)
    reset()
  }

  const onSubmit = async (data) => {
    const payload = { ...data, vehicletype: data.vehicletype.id, Marque: data.Marque.id }
    const response = await makePostRequest('/api/domicile/carpic-operations/', payload, {}, true)
    if (response.status === 201) {
      fetchCarPicModel()
      // fetchCarModel()
      handleClose()
    }
  }

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={true} onClose={handleClose}>
        <DialogTitle sx={{ backgroundColor: '#202020' }}>Ajouter Modele</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('vehicletype', j)
                setSelectedMarque(null)
                // setSelectedVehicleType(j)
              }}
              label="Type de véhicule"
              data={vehiculesTypes}
              name="vehicletype"
              required={true}
              // selectedValue={selectedVehicleType}
            />

            <ComboBox
              handleAutoComplete={(e, j) => {
                setValue('Marque', j)
                setSelectedMarque(j)
              }}
              label="Marque"
              data={carLogoTypes}
              name="Marque"
              required={true}
              selectedValue={selectedMarque}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'text',
              }}
              rules={{ required: true }}
              name="Name"
              label="Modele"
            />

            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                required: true,
                size: 'small',
                type: 'number',
              }}
              rules={{ required: true }}
              name="Emission"
              label="Emission CO2"
            />
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
